import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import * as Sentry from '@sentry/browser';
import { catchError, EMPTY, finalize, Observable, tap } from 'rxjs';
import { getUserId } from 'src/helpers/getUserId';
import reportSentryError from 'src/helpers/reportSentryError';
import { ApiService } from '../api/api.service';
import { LoaderService } from '../components/loader/loader.service';
import { UserData } from '../state/user/user.model';

interface GetUserResponseData {
  data: UserData;
}

@Injectable({
  providedIn: 'root',
})
export class UserService {
  readonly userData = signal<UserData | null>(null);
  readonly userError = signal(false);
  private readonly loader = inject(LoaderService);
  private readonly httpClient = inject(HttpClient);
  private readonly apiService = inject(ApiService);

  fetchUserData(): Observable<GetUserResponseData> {
    this.loader.setLoader(true);
    this.userError.set(false);

    return this.httpClient
      .get<GetUserResponseData>(`${this.apiService.createBffUrl({ path: 'user', useRegion: true })}/get`, {
        withCredentials: true,
      })
      .pipe(
        catchError((error) => {
          reportSentryError({
            error,
            customErrorName: 'Get User Data Error',
            endpointName: 'get-user-data',
          });

          console.error({ error });

          this.userError.set(true);
          return EMPTY;
        }),
        tap((responseData) => {
          this.userData.set(responseData.data);

          Sentry.setUser({ email: responseData.data.email, id: getUserId() });
          Sentry.setExtra('phone', responseData.data.phone);
        }),
        finalize(() => this.loader.setLoader(false)),
      );
  }
}
